import React from 'react';
import { Settings as SettingsValues } from '../../hooks/useSettings';
import styles from './Apps.module.css';

interface SettingsProps {
    settings: SettingsValues;
    onChange: (patch: Partial<SettingsValues>) => void;
    onArrangeWindows: () => void;
}

const SLIDERS: { key: 'scanlines' | 'curvature' | 'noise'; label: string }[] = [
    { key: 'scanlines', label: '주사선' },
    { key: 'curvature', label: '화면 곡률' },
    { key: 'noise', label: '노이즈' },
];

/** 화면 설정. 여기 있는 항목은 전부 바로 화면에 반영된다. */
export const Settings: React.FC<SettingsProps> = ({ settings, onChange, onArrangeWindows }) => (
    <div className={styles.settings}>
        <h2 className={styles.settingsTitle}>화면 설정</h2>

        <button
            type="button"
            className={styles.settingRow}
            aria-pressed={settings.crt}
            onClick={() => onChange({ crt: !settings.crt })}
        >
            CRT 효과
            <span className={settings.crt ? styles.switchOn : styles.switchOff}>{settings.crt ? 'ON' : 'OFF'}</span>
        </button>

        {SLIDERS.map(({ key, label }) => (
            <label key={key} className={styles.rangeRow}>
                {label}
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    value={settings[key]}
                    disabled={!settings.crt}
                    onChange={(event) => onChange({ [key]: Number(event.target.value) })}
                />
                <span>{Math.round(settings[key] * 100)}%</span>
            </label>
        ))}

        <button
            type="button"
            className={styles.settingRow}
            aria-pressed={settings.screensaver}
            onClick={() => onChange({ screensaver: !settings.screensaver })}
        >
            화면보호기
            <span className={settings.screensaver ? styles.switchOn : styles.switchOff}>{settings.screensaver ? 'ON' : 'OFF'}</span>
        </button>
        <p className={styles.settingHint}>열린 패널이 5초마다 자리를 옮깁니다</p>

        <div className={styles.settingsGap} />
        <button
            type="button"
            className={styles.button}
            style={{ marginTop: 0 }}
            disabled={settings.screensaver}
            onClick={onArrangeWindows}
        >
            열린 패널 정렬
        </button>
    </div>
);

export default Settings;
